import "antd/dist/antd.css";
import { useMediaQuery } from "@material-ui/core";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";

import PaginatedTable from "components/organisms/PaginatedTable";
import { findProductName } from "helpers";
import { ProductTypeEnum, SidebarLayoutSingleTeam } from "reactQuery/hooks/apiTypes";

import { useStyles } from "./styles.js";

interface ReportDetailsTemplateProps {
    feedType: string;
    teamId?: number;
    team: SidebarLayoutSingleTeam;
}

export const ReportDetailsTemplate = ({
    feedType,
    teamId,
    team,
}: ReportDetailsTemplateProps) => {
    const styles = useStyles();

    const teamProducts = team?.products;
    const intelligenceReportsProductName = findProductName(
        teamProducts,
        ProductTypeEnum.INTELLIGENCE_REPORTS
    );

    const toolBar = (
        <div className={styles.toolbar}>
            <div className={styles.searchBarContainer}>
                <Typography className={styles.toolbarTitle}>All Insights</Typography>
            </div>
        </div>
    );

    const header = (
        <div>
            <div className={styles.bodyHeader}>
                <div className={styles.bodyHeaderLeft}>
                    <div className={styles.titleContainer}>
                        <Breadcrumbs separator="/">
                            <Typography className={styles.reportsLink}>
                                {team ? team.name : null}
                            </Typography>
                            <Typography color="textPrimary">
                                {intelligenceReportsProductName}
                            </Typography>
                        </Breadcrumbs>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div>
            <div>{header}</div>
            <div>{toolBar}</div>
            <PaginatedTable feedType={feedType} teamId={teamId} />
        </div>
    );
};

export default ReportDetailsTemplate;
